import React from 'react';
import { motion } from 'framer-motion';

const clients = [
  { name: 'Dandy Mega Mall', industry: 'Shopping Mall', file: 'dandy-mega-mall-logo.png' },
  { name: 'Genena Mall', industry: 'Shopping Mall', file: 'genena-mall-logo.png' },
  { name: 'CPC', industry: 'Oil & Fuel Station', file: 'cpc-logo.png' },
  { name: 'B.TECH', industry: 'Electronics Retail', file: 'btech-logo.png' },
  { name: 'Max Muscle', industry: 'Fitness & Nutrition', file: 'maxmuscle-logo.png' },
  { name: 'Green Cafe', industry: 'Cafe & Restaurant', file: 'green-cafe-logo.png' },
];

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { staggerChildren: 0.12, delayChildren: 0.2 },
  },
};

const itemVariants = {
  hidden: { opacity: 0, y: 24 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.5, ease: 'easeOut' },
  },
};

const ClientTrustSection = () => {
  return (
    <motion.section
      className="client-trust-section py-16 px-4 bg-gradient-to-b from-white to-gray-50 will-change-transform"
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.2 }}
      transition={{ duration: 0.6, ease: 'easeOut' }}
    >
      <div className="max-w-7xl mx-auto">
        <motion.h2
          className="text-2xl sm:text-3xl font-bold text-gray-900 text-center mb-4 will-change-transform"
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.1 }}
        >
          Trusted by Industry Leaders
        </motion.h2>

        <motion.p
          className="text-lg text-gray-600 text-center mb-12 sm:mb-16 max-w-3xl mx-auto will-change-transform"
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.2 }}
        >
          Leading businesses across the Middle East trust PROMOTLY for their loyalty programs
        </motion.p>

        <motion.div
          className="grid grid-cols-2 md:grid-cols-3 gap-6 sm:gap-8 max-w-5xl mx-auto"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }}
        >
          {clients.map((client) => (
            <motion.div
              key={client.file}
              className="group flex flex-col items-center bg-white rounded-xl p-6 sm:p-8 shadow-md hover:shadow-xl border border-gray-100 hover:border-blue-200 transition-all duration-300 will-change-transform"
              variants={itemVariants}
            >
              <div className="w-full h-20 sm:h-24 flex items-center justify-center mb-4">
                <img
                  src={`/assets/images/clients/${client.file}`}
                  alt={client.name}
                  className="max-w-full max-h-full object-contain transition-all duration-500 ease-in-out filter grayscale group-hover:grayscale-0 group-hover:scale-105 will-change-transform"
                  loading="lazy"
                />
              </div>
              <span className="text-sm font-semibold text-gray-800 text-center">
                {client.name}
              </span>
              <span className="text-xs text-gray-500 mt-1 text-center">
                {client.industry}
              </span>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </motion.section>
  );
};

export default ClientTrustSection;
